import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Form, Button, Container, Alert, Spinner } from 'react-bootstrap';
import { API_BASE_URL } from '../../config/constants';
import { auth } from '../login/FirebaseConfig';
import { useNavigate } from 'react-router-dom';

const CrearProductoRestoyBar = () => {
    const [nombre, setNombre] = useState('');
    const [precio, setPrecio] = useState('');
    const [descripcion, setDescripcion] = useState('');
    const [imagen, setImagen] = useState(null);
    const [categoria, setCategoria] = useState('');
    const [categorias, setCategorias] = useState([]);

    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);

    const navigate = useNavigate();
    const COLLECTION_RESTOYBAR_NAME = "restoybar";

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const idToken = await auth.currentUser.getIdToken();
            let imagePublicId = "";
            const formData = new FormData();
            if (imagen !== null) {
                formData.append("file", imagen);
                const responseImage = await axios.post(`${API_BASE_URL}/subirImagen`, formData, {
                    headers: {
                        Authorization: `Bearer ${idToken}`,
                    },
                });
                imagePublicId = responseImage.data.public_id;
            }
            const response = await axios.post(
                `${API_BASE_URL}/crearProducto`,
                { collectionName: COLLECTION_RESTOYBAR_NAME, categoriaName: categoria, nombreProducto: nombre, descripcion, precio, imagePublicId, destacado: false },
                {
                    headers: {
                        Authorization: `Bearer ${idToken}`,
                    },
                }
            );

            navigate("/administradorRestoyBar");
            window.location.reload();
        } catch (error) {
            setError(error.response?.data?.error || 'Error al crear el evento');
        } finally {
            setLoading(false);
        }
    };

    const handleCancelar = async () => {
        navigate('/administradorRestoyBar');
    };

    useEffect(() => {
        const fetchCategorias = async () => {
            try {
                const idToken = await auth.currentUser.getIdToken();
                const response = await axios.post(`${API_BASE_URL}/getDocumentos`, { collectionName: COLLECTION_RESTOYBAR_NAME },
                    {
                        headers: {
                            Authorization: `Bearer ${idToken}`,
                        },
                    }
                );

                if (response.data.doc_ids) {
                    setCategorias(response.data.doc_ids);
                }
            } catch (error) {
                console.error("Error obteniendo las categorías:", error);
            }
        };

        fetchCategorias();
    }, []);

    return (
        <Container className="mt-5 divfill">
            <h3>Crear Producto</h3>
            {error && <Alert variant="danger">{error}</Alert>}

            <Form onSubmit={handleSubmit}>
                <Form.Group controlId="formNombre">
                    <Form.Label>Nombre *</Form.Label>
                    <Form.Control
                        type="text"
                        placeholder="Ingrese el nombre del Producto"
                        value={nombre}
                        onChange={(e) => setNombre(e.target.value)}
                        className="mb-2"
                        required
                    />
                </Form.Group>

                <Form.Group controlId="formDescripcion">
                    <Form.Label>Descripción</Form.Label>
                    <Form.Control
                        type="text"
                        placeholder="Ingrese la descripción del Producto"
                        value={descripcion}
                        onChange={(e) => setDescripcion(e.target.value)}
                        className="mb-2"
                    />
                </Form.Group>

                <Form.Group controlId="formPrecio">
                    <Form.Label>Precio</Form.Label>
                    <Form.Control
                        type="number"
                        placeholder="$"
                        value={precio}
                        onChange={(e) => setPrecio(e.target.value)}
                        min="0"
                        step="0.01"
                        className="mb-2"
                    />
                </Form.Group>

                <Form.Group controlId="formImagen">
                    <Form.Label>Imagen del Producto</Form.Label>
                    <Form.Control
                        type="file"
                        accept="image/*"
                        onChange={(e) => setImagen(e.target.files[0])}
                        className="mb-2"
                    />
                </Form.Group>

                <Form.Group controlId="formCategoria">
                    <Form.Label>Categoría *</Form.Label>
                    <Form.Select
                        value={categoria}
                        onChange={(e) => setCategoria(e.target.value)}
                        className={"mb-2"}
                        required
                    >

                        <option disabled value="">Seleccione una categoría</option>
                        {categorias.map((categoria) => (
                            <option key={categoria} value={categoria}>
                                {categoria}
                            </option>
                        ))}
                    </Form.Select>
                </Form.Group>
                <p style={{ fontSize: "0.85em", color: "rgba(0, 0, 0, 0.6)", marginTop: "10px" }}>
                    Los campos marcados con <span>(*)</span> son obligatorios.
                </p>
                <Button variant="primary" type="submit" className="my-2" disabled={loading}>
                    {loading ? (
                        <Spinner animation="border" size="sm" />
                    ) : (
                        'Crear Producto'
                    )}
                </Button>
                <Button type="button" className="btn btn-danger my-2 mx-2" onClick={handleCancelar}>Cancelar</Button>
            </Form>
        </Container >
    );
};

export default CrearProductoRestoyBar;
